module.exports = __webpack_public_path__ + "files/SPIADI2020 - Rapport annuel d'activité.ef5cf5fc4a1d8296c063cd159331fe1d.pdf";